module.exports = __webpack_public_path__ + "img/followInterests.6beae29e.svg";